var map = {
	"./av_gutewahl-helm.mp3": 7999,
	"./av_gutewahl-sichtbar.mp3": 8551,
	"./av_intro.mp3": 2623,
	"./rf_0_leider-falsch.mp3": 801,
	"./rf_0_richtig.mp3": 9436,
	"./rf_0_was-ist-richtig.mp3": 8905,
	"./rf_1.mp3": 7221,
	"./rf_10.mp3": 3475,
	"./rf_2.mp3": 1796,
	"./rf_3.mp3": 9322,
	"./rf_4.mp3": 1893,
	"./rf_5.mp3": 4848,
	"./rf_6.mp3": 3587,
	"./rf_7.mp3": 6567,
	"./rf_8.mp3": 3674,
	"./rf_9.mp3": 4962,
	"./rf_ende.mp3": 607,
	"./wb_ende.mp3": 5409,
	"./wb_finde-blumen.mp3": 6131,
	"./wb_finde-fahrrad.mp3": 2395,
	"./wb_finde-katzen.mp3": 7854,
	"./wb_finde-muell.mp3": 6576,
	"./wb_finde-roller.mp3": 7031,
	"./wb_finde-voegel.mp3": 6504,
	"./wb_gefunden-blumen.mp3": 8373,
	"./wb_gefunden-fahrrad.mp3": 4729,
	"./wb_gefunden-katzen.mp3": 3377,
	"./wb_gefunden-muell.mp3": 5845,
	"./wb_gefunden-roller.mp3": 3117,
	"./wb_gefunden-voegel.mp3": 699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1866;